export default __webpack_public_path__ + "static/media/FugitiveEmissions_icon.3569fe03.svg";